import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
	providedIn: 'root',
})
export class EncryptionUtilService {
	_key: string = '1956567915675679';
	_initVector: string = '9239567195645678';
	constructor() {}

	encrypt(value: string): string {
		const key = CryptoJS.enc.Utf8.parse(this._key);
		const iv = CryptoJS.enc.Utf8.parse(this._initVector);
		const encrypted = CryptoJS.AES.encrypt(value, key, {
			keySize: 16,
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});
		return encrypted.toString();
	}

	decrypt(encrypted: string) {
		const key = CryptoJS.enc.Utf8.parse(this._key);
		const iv = CryptoJS.enc.Utf8.parse(this._initVector);
		const decrypt = CryptoJS.AES.decrypt(encrypted, key, {
			keySize: 16,
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});
		return decrypt.toString(CryptoJS.enc.Utf8);
	}
}
